module.exports = __webpack_public_path__ + "Flag-238.72b2f2b02aea16b5b33b6b223caa9b1c.svg";